/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {GrabTourComponent as ɵa} from './lib/grab-tour/grab-tour.component';
export {SurfGetPaxDisplayTextPipe as ɵb} from './lib/pipe/surf-get-pax-display-text.pipe';
export {SurfGrabTourDurationStringPipe as ɵc} from './lib/pipe/surf-grab-tour-duration-string.pipe';